"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Twitter, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-foreground hover:text-primary-dark transition-colors duration-200 hover:underline underline-offset-4">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="w-full bg-background border-t border-primary/20 py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="text-sm text-foreground">
            &copy; {currentYear} Agentic Artist. All rights reserved.
            <Link to="https://agenticartist.net/privacy-policy/" newTab className="ml-4 hover:text-primary-dark transition-colors duration-200 underline underline-offset-4">
              Privacy Policy
            </Link>
          </div>

          {}
          <MenuProvider menu_id="18">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex items-center gap-4">
            <Link to="https://facebook.com" newTab className="text-foreground hover:text-primary-dark transition-all duration-200 hover:scale-110" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://twitter.com" newTab className="text-foreground hover:text-secondary transition-all duration-200 hover:scale-110" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
            <Link to="https://instagram.com" newTab className="text-foreground hover:text-accent-dark transition-all duration-200 hover:scale-110" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}